<div class="dialog-container">
    <div class="grid p-fluid p-input-filled dialog-row">
        <div class="col-12">
            <label>Depot *</label>
            <p-dropdown dataKey="id" [options]="(depots$ | async)" [(ngModel)]="device.depot" optionLabel="name" [showClear]="false" [ngClass]="{'ng-invalid ng-dirty': isDepotInvalid}"></p-dropdown>
            <small *ngIf="isDepotInvalid" class="p-error">Depot ist erforderlich</small>
        </div>
    </div>
    <div class="grid p-fluid p-input-filled dialog-row">
        <div class="col-6">
            <span class="p-float-label">
                <input type="text" [(ngModel)]="device.account" pInputText [ngClass]="{'ng-invalid ng-dirty': isAccountInvalid}">
                <label>Account *</label>
            </span>
            <small *ngIf="isAccountInvalid" class="p-error">Account ist erforderlich</small>
        </div>
        <div class="col-6">
            <span class="p-float-label">
                <input type="text" [(ngModel)]="device.accountMail" pInputText>
                <label>Account Mail</label>
            </span>
        </div>
    </div>
    <div class="grid p-fluid p-input-filled dialog-row">
        <div class="col-6">
            <span class="p-float-label">
                <input type="text" [(ngModel)]="device.imeiNumber" pInputText>
                <label>IMEI</label>
            </span>
        </div>
        <div class="col-6">
            <span class="p-float-label">
                <input type="text" [(ngModel)]="device.serialNumber" pInputText>
                <label>Seriennummer</label>
            </span>
        </div>
    </div>
    <div class="grid p-fluid p-input-filled dialog-row">
        <div class="col-6">
            <span class="p-float-label">
                <input type="text" [(ngModel)]="device.phoneNumber" pInputText>
                <label>Telefon-Nr.</label>
            </span>
        </div>
        <div class="col-3">
            <span class="p-float-label">
                <input type="text" [(ngModel)]="device.simPIN" pInputText>
                <label>PIN</label>
            </span>
        </div>
        <div class="col-3">
            <span class="p-float-label">
                <input type="text" [(ngModel)]="device.simPUK" pInputText>
                <label>PUK</label>
            </span>
        </div>
    </div>
</div>
<div style="text-align: right;">
    <p-button icon="fa fa-times" label="Abbrechen" styleClass="p-button-text p-button-danger p-button-lg" (onClick)="cancelAsync()"></p-button>
    <p-button icon="fa fa-check" label="Speichern" styleClass="p-button-text p-button-success p-button-lg" [disabled]="(canSave === false)" (onClick)="saveAsync()"></p-button>
</div>

